export default "__VITE_ASSET__BjQoogSS__"